import { render, staticRenderFns } from "./Caracteristicas.vue?vue&type=template&id=1b15f3ca&scoped=true&"
import script from "./Caracteristicas.vue?vue&type=script&lang=js&"
export * from "./Caracteristicas.vue?vue&type=script&lang=js&"
import style0 from "./Caracteristicas.vue?vue&type=style&index=0&id=1b15f3ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b15f3ca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/opt/build/repo/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VContainer,VFlex,VLayout})
